import { render, staticRenderFns } from "./electricityList.vue?vue&type=template&id=651eb9fa&scoped=true&"
import script from "./electricityList.vue?vue&type=script&lang=js&"
export * from "./electricityList.vue?vue&type=script&lang=js&"
import style0 from "./electricityList.vue?vue&type=style&index=0&id=651eb9fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651eb9fa",
  null
  
)

export default component.exports